export const hasPermission = (menuSlug: any, action: any) => {
    try {
      const authDataRaw: string | null = localStorage.getItem("authData");
      if (!authDataRaw) return false;

      const authData = JSON.parse(authDataRaw);
      // Admin bypass - matches Sidebar behavior
      if (authData?.roleId?.roleId === 1) return true;

      const permissions = authData.permissions || [];

      const menu = permissions.find(
        (item: any) => item.menuId?.slug === menuSlug
      );

      return menu?.permissionIds?.[action] || false;
    } catch (error) {
      console.error("Permission check failed:", error);
      return false;
    }
  };
  